import { useLayoutEffect, useRef } from 'react';

// Joins the last word to the one before it, so a text doesn't end in a word alone on its last line. Running it again
// changes nothing: the joining space counts as whitespace but not as part of a word.
const keepLastWordsTogether = (element: HTMLElement) => {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    let last: Text | undefined;
    while (walker.nextNode()) {
        const node = walker.currentNode as Text;
        if (node.data.trim()) last = node;
    }
    if (last) last.data = last.data.replace(/\s+(\S+\s*)$/, ' $1');
};

// For an element with `text-pretty`, in browsers without `text-wrap: pretty` (Firefox), which already avoids a word
// alone on the last line. React only writes a text node when its text changes, so this runs after every render to
// catch new text.
const usePrettyWrap = <T extends HTMLElement>() => {
    const ref = useRef<T>(null);

    useLayoutEffect(() => {
        // Asked here rather than once when the module loads, which also happens in Node, where the start page is
        // prerendered (web/prerender.mjs) and there's no CSS.
        if (!CSS.supports('text-wrap', 'pretty') && ref.current) keepLastWordsTogether(ref.current);
    });

    return ref;
};

export default usePrettyWrap;
